<template>
  <div>
    <GoodTable
      :rows="rows"
      :columns="columns"
      :totalPage="totalPage"
      :page="page"
      :sortField="sortField"
      :lineNumbers="lineNumbers"
      :selectOption="selectOption"
      :pagination="false"
      :noneBorder="noneBorder"
      :nodata="nodata"
      className="style-duo-care"
      height="500px"
      @pagination="changePage($event)"
    >
      <template #head.programName>
        <div class="d-flex">
          <span class="text-center my-auto">Khung chương trình</span>
          <filterSelect
            v-if="listProgram && listProgram.length"
            :items="listProgram"
            item-value="name"
            item-title="name"
            @input="changeValue($event)"
          ></filterSelect>
        </div>
      </template>
      <template #head.courseName>
        <div class="d-flex">
          <span class="text-center my-auto">Khoá học</span>
          <filterSelect
            v-if="listCourses && listCourses.length"
            :items="listCourses"
            item-value="courseId"
            item-title="courseName"
            @input="changeValue($event)"
          ></filterSelect>
        </div>
      </template>
      <template #lessonStartTime="item">
        <div>
          <div
            v-html="formateTime(item.lessonStartTime, item.lessonEndTime)"
          ></div>
        </div>
      </template>
      <template #isCheckAttendance="item">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="d-flex justify-center">
              <span v-if="item.isCheckAttendance">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.5 7.75C0.5 3.89453 3.61719 0.75 7.5 0.75C11.3555 0.75 14.5 3.89453 14.5 7.75C14.5 11.6328 11.3555 14.75 7.5 14.75C3.61719 14.75 0.5 11.6328 0.5 7.75ZM10.6445 6.54688C10.9453 6.24609 10.9453 5.78125 10.6445 5.48047C10.3438 5.17969 9.87891 5.17969 9.57812 5.48047L6.625 8.43359L5.39453 7.23047C5.09375 6.92969 4.62891 6.92969 4.32812 7.23047C4.02734 7.53125 4.02734 7.99609 4.32812 8.29688L6.07812 10.0469C6.37891 10.3477 6.84375 10.3477 7.14453 10.0469L10.6445 6.54688Z"
                    fill="#4CAF50"
                  />
                </svg>
              </span>
              <span v-else>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <rect
                    width="14"
                    height="14"
                    fill="url(#pattern0_17465_998)"
                  />
                  <defs>
                    <pattern
                      id="pattern0_17465_998"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use
                        xlink:href="#image0_17465_998"
                        transform="scale(0.0625)"
                      />
                    </pattern>
                    <image
                      id="image0_17465_998"
                      width="16"
                      height="16"
                      xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAHiSURBVDiNlZI9b1JhFMd/53nuvQwwlVWgXRykOpQwmBgT22KU+i0gaSS1Nml05gM4lGKsjS/fomlsQxN1JE1ccMbr3C7F4QL3Hgeo5SIa/U8n5zn/33nJI0wpaGQWRaSiIiUgh6Aovqgeq+FtYsPvTNbLZaD1vBfM9XZEWAfMNHisUGDPPUttS73T/wXQet4bpHuHCst/MMYkSss9T5Wl3ukbgGCut/OvZgAVVgbp3gsAEzSv3RyPPZKXxN5+Dta7clhvlPOSVxCoBS+zeSPiVCd3tks1bKGGU94fQayHU97HFmrYpdrkIFZUKo6qrk5mw/YOkr6OWSjhPHoH4QCTu0fkfyRs78ZXgZIEzdwFkIq9WBfn4WvM/AoAkf+Z4UEVwiB+DOHCIOjsU8lEKLNLFDUo33/r/mAPM79M5H8i6rYwmTs4a2/AJqYRvhHVo5i/uIVZWCXqnjA8qDI8fEzUPcFk72KLm/EZhQ8SNDKLGPMFsAC4SWyhRthuQNgfUz1s8Snh6SsY/Lj0h6jeEoB+M9dU2Ji96GwJ0vCedLcMgHuW2hal9R/mY9dLP4PxB5J6p++ep8oCTSD8i3coSMP10muyfjoYwaYU7GZvCFJR4T5CDkVBvonokUb6PrHpf52s/wmoBaCVLGddqAAAAABJRU5ErkJggg=="
                    />
                  </defs>
                </svg>
              </span>
            </div>
          </template>
          <div>
            <div>
              Vào lớp:
              <span v-if="item.joinAt" class="mx-2">{{
                formatHour(item.joinAt)
              }}</span>
              <span v-else class="mx-2">--</span>
            </div>
            <div>
              Rời Lớp:
              <span v-if="item.outAt" class="mx-2">{{
                formatHour(item.outAt)
              }}</span>
              <span v-else class="mx-2">--</span>
            </div>
          </div>
        </v-tooltip>
      </template>
      <template #homework="item">
        <div v-if="item.homeworks && item.homeworks.length">
          <div
            v-for="(homew, index) in item.homeworks"
            :key="'hw' + index"
            class="my-2"
          >
            <span class="mr-2">{{ homew.name }}:</span>
            <span v-if="homew.isDo">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <a
                    :href="homew.lmsResultLink"
                    target="_blank"
                    class="custome-link"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ homew.totalCorrect }}/{{ homew.totalQuestion }}
                  </a>
                </template>
                <div>
                  <div>
                    Làm bài:
                    <span v-if="homew.startTime" class="mx-2"
                      >{{ formatDateSlash(homew.startTime) }}
                      {{ formatHour(homew.startTime) }}</span
                    >
                    <span v-else class="mx-2">--</span>
                  </div>
                </div>
              </v-tooltip>
            </span>
            <span v-else>
              <a
                :href="homew.lmsLink"
                target="_blank"
                style="color: #ff7800; text-decoration: none"
              >
                Chưa làm
              </a>
            </span>
          </div>
        </div>
        <div v-else>
          Không có BTVN
        </div>
      </template>
      <template #homeworks="item">
        <div v-if="item.homeworks && item.homeworks.length">
          <div
            v-for="(homew, index) in item.homeworks"
            :key="'hw' + index"
            class="my-2"
          >
            <span class="mr-2">{{ homew.name }}:</span>
            <span v-if="homew.status">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <a
                    :href="homew.lmsResultLink"
                    target="_blank"
                    class="custome-link"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ homew.correctQuestion }}/{{ homew.totalQuestion }}
                  </a>
                </template>
                <div>
                  <div>
                    Làm bài:
                    <span v-if="homew.doPracticeAt" class="mx-2"
                      >{{ formatDateSlash(homew.doPracticeAt) }}
                      {{ formatHour(homew.doPracticeAt) }}</span
                    >
                    <span v-else class="mx-2">--</span>
                  </div>
                </div>
              </v-tooltip>
            </span>
            <span v-else>
              <a
                :href="homew.lmsLink"
                target="_blank"
                style="color: #ff7800; text-decoration: none"
              >
                Chưa làm
              </a>
            </span>
          </div>
        </div>
        <div v-else>
          <svg
            width="20"
            height="4"
            viewBox="0 0 20 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="4" rx="2" fill="#D9D9D9" />
          </svg>
        </div>
      </template>
      <template #noCups="item">
        <div v-if="item.noCups" class="text-center">
          <div class="d-flex justify-center">
            <div class="mr-2">{{ item.noCups }}</div>
            <div><img src="../../assets/cup-icon.svg" alt="" /></div>
          </div>
          <div>{{item.interactionScore}} điểm</div>
        </div>
        <div v-else class="d-flex justify-center">
          <svg
            width="20"
            height="4"
            viewBox="0 0 20 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="4" rx="2" fill="#D9D9D9" />
          </svg>
        </div>
      </template>
      <template #videos="item">
          <div v-if="item.videos && item.videos.length">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="d-flex justify-center">
                    <span v-if="checkViewedVideo(item.videos)">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.5 7.75C0.5 3.89453 3.61719 0.75 7.5 0.75C11.3555 0.75 14.5 3.89453 14.5 7.75C14.5 11.6328 11.3555 14.75 7.5 14.75C3.61719 14.75 0.5 11.6328 0.5 7.75ZM10.6445 6.54688C10.9453 6.24609 10.9453 5.78125 10.6445 5.48047C10.3438 5.17969 9.87891 5.17969 9.57812 5.48047L6.625 8.43359L5.39453 7.23047C5.09375 6.92969 4.62891 6.92969 4.32812 7.23047C4.02734 7.53125 4.02734 7.99609 4.32812 8.29688L6.07812 10.0469C6.37891 10.3477 6.84375 10.3477 7.14453 10.0469L10.6445 6.54688Z"
                          fill="#4CAF50"
                        />
                      </svg>
                    </span>
                    <span v-else>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          width="14"
                          height="14"
                          fill="url(#pattern0_17465_998)"
                        />
                        <defs>
                          <pattern
                            id="pattern0_17465_998"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              xlink:href="#image0_17465_998"
                              transform="scale(0.0625)"
                            />
                          </pattern>
                          <image
                            id="image0_17465_998"
                            width="16"
                            height="16"
                            xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAHiSURBVDiNlZI9b1JhFMd/53nuvQwwlVWgXRykOpQwmBgT22KU+i0gaSS1Nml05gM4lGKsjS/fomlsQxN1JE1ccMbr3C7F4QL3Hgeo5SIa/U8n5zn/33nJI0wpaGQWRaSiIiUgh6Aovqgeq+FtYsPvTNbLZaD1vBfM9XZEWAfMNHisUGDPPUttS73T/wXQet4bpHuHCst/MMYkSss9T5Wl3ukbgGCut/OvZgAVVgbp3gsAEzSv3RyPPZKXxN5+Dta7clhvlPOSVxCoBS+zeSPiVCd3tks1bKGGU94fQayHU97HFmrYpdrkIFZUKo6qrk5mw/YOkr6OWSjhPHoH4QCTu0fkfyRs78ZXgZIEzdwFkIq9WBfn4WvM/AoAkf+Z4UEVwiB+DOHCIOjsU8lEKLNLFDUo33/r/mAPM79M5H8i6rYwmTs4a2/AJqYRvhHVo5i/uIVZWCXqnjA8qDI8fEzUPcFk72KLm/EZhQ8SNDKLGPMFsAC4SWyhRthuQNgfUz1s8Snh6SsY/Lj0h6jeEoB+M9dU2Ji96GwJ0vCedLcMgHuW2hal9R/mY9dLP4PxB5J6p++ep8oCTSD8i3coSMP10muyfjoYwaYU7GZvCFJR4T5CDkVBvonokUb6PrHpf52s/wmoBaCVLGddqAAAAABJRU5ErkJggg=="
                          />
                        </defs>
                      </svg>
                    </span>
                  </div>
                </template>
                <div>
                  <div>
                    Xem Video:
                    <span class="mx-2">{{
                      findWatchAtVideo(item.videos)
                    }}</span>
                  </div>
                </div>
              </v-tooltip>
            </div>
          </div>
          <div v-else class="d-flex justify-center">
          <svg
            width="20"
            height="4"
            viewBox="0 0 20 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="4" rx="2" fill="#D9D9D9" />
          </svg>
        </div>
      </template>
      <template #rank="item">
        <div v-if="item.rank" class="d-flex justify-center">
          <div v-if="item.rank <= 20" class="mr-2">Top {{item.rank}}</div>
          <div v-else class="mr-2">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="d-flex justify-center">
                    <span class="mr-2">Top 20+</span>
                  </div>
                </template>
                <div>
                  <div>
                    Top {{item.rank}}
                  </div>
                </div>
              </v-tooltip>
          </div>
        </div>
        <div v-else class="d-flex justify-center">
          <svg
            width="20"
            height="4"
            viewBox="0 0 20 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="4" rx="2" fill="#D9D9D9" />
          </svg>
        </div>
      </template>
      <template #documents="item">
          <div v-if="item.documents && item.documents.length">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="d-flex justify-center">
                    <span v-if="checkViewedVideo(item.documents)">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.5 7.75C0.5 3.89453 3.61719 0.75 7.5 0.75C11.3555 0.75 14.5 3.89453 14.5 7.75C14.5 11.6328 11.3555 14.75 7.5 14.75C3.61719 14.75 0.5 11.6328 0.5 7.75ZM10.6445 6.54688C10.9453 6.24609 10.9453 5.78125 10.6445 5.48047C10.3438 5.17969 9.87891 5.17969 9.57812 5.48047L6.625 8.43359L5.39453 7.23047C5.09375 6.92969 4.62891 6.92969 4.32812 7.23047C4.02734 7.53125 4.02734 7.99609 4.32812 8.29688L6.07812 10.0469C6.37891 10.3477 6.84375 10.3477 7.14453 10.0469L10.6445 6.54688Z"
                          fill="#4CAF50"
                        />
                      </svg>
                    </span>
                    <span v-else>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          width="14"
                          height="14"
                          fill="url(#pattern0_17465_998)"
                        />
                        <defs>
                          <pattern
                            id="pattern0_17465_998"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              xlink:href="#image0_17465_998"
                              transform="scale(0.0625)"
                            />
                          </pattern>
                          <image
                            id="image0_17465_998"
                            width="16"
                            height="16"
                            xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAHiSURBVDiNlZI9b1JhFMd/53nuvQwwlVWgXRykOpQwmBgT22KU+i0gaSS1Nml05gM4lGKsjS/fomlsQxN1JE1ccMbr3C7F4QL3Hgeo5SIa/U8n5zn/33nJI0wpaGQWRaSiIiUgh6Aovqgeq+FtYsPvTNbLZaD1vBfM9XZEWAfMNHisUGDPPUttS73T/wXQet4bpHuHCst/MMYkSss9T5Wl3ukbgGCut/OvZgAVVgbp3gsAEzSv3RyPPZKXxN5+Dta7clhvlPOSVxCoBS+zeSPiVCd3tks1bKGGU94fQayHU97HFmrYpdrkIFZUKo6qrk5mw/YOkr6OWSjhPHoH4QCTu0fkfyRs78ZXgZIEzdwFkIq9WBfn4WvM/AoAkf+Z4UEVwiB+DOHCIOjsU8lEKLNLFDUo33/r/mAPM79M5H8i6rYwmTs4a2/AJqYRvhHVo5i/uIVZWCXqnjA8qDI8fEzUPcFk72KLm/EZhQ8SNDKLGPMFsAC4SWyhRthuQNgfUz1s8Snh6SsY/Lj0h6jeEoB+M9dU2Ji96GwJ0vCedLcMgHuW2hal9R/mY9dLP4PxB5J6p++ep8oCTSD8i3coSMP10muyfjoYwaYU7GZvCFJR4T5CDkVBvonokUb6PrHpf52s/wmoBaCVLGddqAAAAABJRU5ErkJggg=="
                          />
                        </defs>
                      </svg>
                    </span>
                  </div>
                </template>
                <div>
                  <div>
                    Xem tài liệu:
                    <span class="mx-2">{{
                      findWatchAtVideo(item.documents)
                    }}</span>
                  </div>
                </div>
              </v-tooltip>
            </div>
          </div>
          <div v-else class="d-flex justify-center">
          <svg
            width="20"
            height="4"
            viewBox="0 0 20 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="4" rx="2" fill="#D9D9D9" />
          </svg>
        </div>
      </template>
    </GoodTable>
  </div>
</template>

<script>
import GoodTable from '@/components/common/GoodTable.vue';
import filterSelect from '@/components/common/FilterSelect.vue';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  components: { GoodTable, filterSelect },
  props: {
    userId: {
      type: Number,
      defautl: null,
    },
    subjectId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      rows: [],
      columns: [],
      columnsDuo: [
        {
          label: 'Thời gian học',
          field: 'lessonStartTime',
          customRow: true,
          thWidth: '150px',
          thClass: 'text-left',
        },
        {
          label: 'Khung chương trình',
          field: 'programName',
          tdClass: 'text-left',
          customHead: true,
          thClass: 'text-left',
        },
        {
          label: 'Buổi học',
          field: 'lessonName',
          thWidth: '200px',
          thClass: 'text-left',
        },
        {
          label: 'Lớp',
          field: 'className',
          thWidth: '180px',
          thClass: 'text-left',
        },
        {
          label: 'Video',
          field: 'videos',
          customRow: true,
          thWidth: '50px',
          thClass: 'text-left',
        },
        {
          label: 'Điểm danh',
          field: 'isCheckAttendance',
          customRow: true,
          thWidth: '50px',
          tdClass: 'text-center',
          thClass: 'text-left',
        },
        {
          label: 'BTVN',
          field: 'homework',
          customRow: true,
          thWidth: '160px',
          thClass: 'text-left',
        },
        {
          label: 'Điểm xếp hạng',
          field: 'rank',
          customRow: true,
          thWidth: '110px',
          thClass: 'text-left',
        },
        {
          label: 'Số cúp đạt',
          field: 'noCups',
          customRow: true,
          thWidth: '100px',
          thClass: 'text-left',
        },
        {
          label: 'Tài liệu',
          field: 'documents',
          customRow: true,
          thClass: 'text-left',
        },
      ],
      columnsSeflStudy: [
        {
          label: 'Ngày học',
          field: 'time',
          thWidth: '150px',
          thClass: 'text-left',
        },
        {
          label: 'Khoá học',
          field: 'courseName',
          tdClass: 'text-left',
          customHead: true,
          thClass: 'text-left',
        },
        {
          label: 'Bài học',
          field: 'sectionName',
          thWidth: '400px',
          thClass: 'text-left',
        },
        {
          label: 'BTVN',
          field: 'homeworks',
          customRow: true,
          thWidth: '180px',
          thClass: 'text-left',
        },
        {
          label: 'Video',
          field: 'videos',
          customRow: true,
          thWidth: '50px',
          thClass: 'text-left',
        },
        {
          label: 'Tài liệu',
          field: 'documents',
          customRow: true,
          thClass: 'text-left',
        },
      ],
      totalPage: null,
      page: 1,
      sortField: {},
      lineNumbers: {},
      selectOption: false,
      pagination: true,
      height: '',
      noneBorder: true,
      nodata: 'Không có dữ liệu kết quả học tập!',
      filterProgram: {
        name: [],
      },
      listProgram: [],
      cloneRows: [],
      listCourses: [],
    };
  },
  computed: {
    ...mapState('duo_care', ['activeClass', 'filterFormDou', 'selfStudyResult', 'studyResult']),
  },
  async mounted() {
    if (this.activeClass) {
      this.columns = this.columnsSeflStudy;
      await this.getDetailSeflStudy();
    } else {
      this.columns = this.columnsDuo;
      await this.getListStudyDuo();
    }
  },
  watch: {
    selfStudyResult: {
      handler(val) {
        this.rows = [];
        this.columns = this.columnsSeflStudy;
        this.rows = val.bySections;
        this.cloneRows = _.cloneDeep(val.bySections);
        this.listCourses = val.listCourses;
      },
      deep: true,
    },
    studyResult: {
      handler(val) {
        this.rows = [];
        this.columns = this.columnsDuo;
        this.rows = val.byLesson;
        this.cloneRows = _.cloneDeep(val.byLesson);
        this.listProgram = val.listProgram;
      },
      deep: true,
    },
  },
  methods: {
    async getListStudyDuo() {
      this.rows = this.studyResult.byLesson;
      this.cloneRows = _.cloneDeep(this.studyResult.byLesson);
      this.listProgram = this.studyResult.listProgram;
    },
    async getDetailSeflStudy() {
      this.rows = this.selfStudyResult.bySections;
      this.cloneRows = _.cloneDeep(this.selfStudyResult.bySections);
      this.listCourses = this.selfStudyResult.listCourses;
    },
    formateTime(startTime, endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);
      return `<div>${start.getDate()}/${
        start.getMonth() + 1
      }/${start.getFullYear()}</div><div>${moment(start).format(
        'HH:mm',
      )} - ${moment(end).format('HH:mm')}</div>`;
    },
    changeValue(value) {
      const data = _.cloneDeep(this.cloneRows);
      if (value.length === 0) {
        this.rows = data;
        return;
      }
      this.filterProgram.name = value;
      if (this.activeClass) {
        this.rows = data.filter((item) => this.filterProgram.name.includes(item.courseId));
      } else {
        this.rows = data.filter((item) => this.filterProgram.name.includes(item.programName));
      }
    },
    checkViewedVideo(videos) {
      const viewed = videos.find((item) => item.status === 1);
      if (viewed) {
        return true;
      }
      return false;
    },
    findWatchAtVideo(videos) {
      const viewed = _.maxBy(videos, 'watchAt');
      if (viewed) {
        return this.formatDateSlash(viewed.watchAt);
      }
      return '--';
    },
  },
};
</script>

<style lang="scss" scoped>
.custome-link {
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
</style>
